import React, { useEffect } from 'react';
import styled from 'styled-components';
// ROUTER
import { routes } from 'routes';
import { Link as RouterLink, useParams } from 'react-router-dom';
// REDUX
import { connect, useDispatch } from 'react-redux';
import { operationFetchBanners } from 'redux/operations/fetch';
// COMPONENTS
import Image from 'components/atoms/Image/Image';
import Link from 'components/atoms/Link/Link';
import CardClassic from 'components/molecules/CardClassic/CardClassic';
import Banners from 'components/molecules/Banners/Banners';

const AsideWrapper = styled.aside`
	/* background-color: ${({ theme }) => theme.grey100}; */
	${Link} {
		font-size: 0.7rem;
	}
`;

const StyledShield = styled(Image)`
	width: 60%;
	max-width: 12rem;
	margin-bottom: 1rem;
`;
const StyledText = styled.p`
	margin-bottom: 0;
	font-size: 0.9rem;
	font-weight: ${({ theme }) => theme.bold};
	color: ${({ theme }) => theme.primary};
`;

const getAsideNavItems = ({ records, ranking }) => {
	const items = [];
	for (let pageIndex = 0, from = 1, to = 100, x = 0; x < records; pageIndex++, x += 100) {
		items.push(
			<div className="col-4 col-sm-3 col-md-2 col-lg-4" key={pageIndex}>
				<Link
					as={RouterLink}
					to={`${routes.rankings}/${ranking}?pageIndex=${pageIndex}&pageSize=100`}
				>{`${from}-${to}`}</Link>
			</div>,
		);
		from += 100;
		to += 100;
	}
	return items;
};

const Aside = ({ shield, winners, banners, voivodeships, hashBanners }) => {
	const dispatch = useDispatch();
	const { slug } = useParams();

	useEffect(() => {
		if (!banners[slug] && hashBanners[slug]) {
			dispatch(operationFetchBanners({ hash: hashBanners[slug], id: slug }));
		}
	}, [slug]);

	return (
		<AsideWrapper>
			{banners[slug] && <Banners banners={banners[slug]} />}

			<div className="text-center">
				<Link as={RouterLink} to={routes.rankings}>
					<StyledShield src={shield} alt={process.env.REACT_APP_TITLE} />
				</Link>
			</div>

			{winners &&
				Object.entries(winners).map(([key, value]) => (
					<CardClassic title={value.title} link={`${routes.rankings}/${key}`} orderedList key={key}>
						<StyledText>Miejsca:</StyledText>
						<div className="row">{getAsideNavItems({ records: value.records, ranking: key })}</div>
					</CardClassic>
				))}

			<CardClassic title="Rankingi Wojewódzkie" unorderedList>
				<div className="row">
					{voivodeships.map(({ title, link }, index) => (
						<div className="col-6 col-sm-4 col-lg-6" key={index}>
							<Link as={RouterLink} to={link}>
								{title}
							</Link>
						</div>
					))}
				</div>
			</CardClassic>

			{banners?.global && <Banners banners={banners.global} />}

			{banners?.bannnersFounders && <Banners banners={banners.bannnersFounders} />}
		</AsideWrapper>
	);
};
const mapStateToProps = ({ initial, global, banners }) => ({
	winners: initial.winners,
	hashBanners: initial.banners,
	shield: global.shield,
	voivodeships: global.voivodeships,
	banners,
});

export default connect(mapStateToProps)(Aside);
